
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("5AAF6"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("5AAF6", function(module, exports) {

let $411cc0d5a2a55f53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $411cc0d5a2a55f53$var$load("Kj0I8"),
    $411cc0d5a2a55f53$var$load("5xnun"),
    $411cc0d5a2a55f53$var$load("iUXaE"),
    $411cc0d5a2a55f53$var$load("lTkx9"),
    $411cc0d5a2a55f53$var$load("eRhBr"),
    $411cc0d5a2a55f53$var$load("6HpsR"),
    $411cc0d5a2a55f53$var$load("N3oqb"),
    $411cc0d5a2a55f53$var$load("hZ2FX"),
    $411cc0d5a2a55f53$var$load("9ZFGK"),
    $411cc0d5a2a55f53$var$load("2hLAI"),
    $411cc0d5a2a55f53$var$load("dCilB"),
    $411cc0d5a2a55f53$var$load("h1yOv"),
    $411cc0d5a2a55f53$var$load("1T8H1"),
    $411cc0d5a2a55f53$var$load("fyKFO"),
    $411cc0d5a2a55f53$var$load("d9sg7"),
    $411cc0d5a2a55f53$var$load("l0N35"),
    $411cc0d5a2a55f53$var$load("bU9L5"),
    $411cc0d5a2a55f53$var$load("fuOfV"),
    $411cc0d5a2a55f53$var$load("iZR3N"),
    $411cc0d5a2a55f53$var$load("4zz48"),
    $411cc0d5a2a55f53$var$load("jXM1T"),
    $411cc0d5a2a55f53$var$load("cvcNg"),
    $411cc0d5a2a55f53$var$load("jw3lv"),
    $411cc0d5a2a55f53$var$load("7rqWx"),
    $411cc0d5a2a55f53$var$load("aIze1"),
    $411cc0d5a2a55f53$var$load("il8bj"),
    $411cc0d5a2a55f53$var$load("4N1MY"),
    $411cc0d5a2a55f53$var$load("kG5Ju"),
    $411cc0d5a2a55f53$var$load("39XCn"),
    $411cc0d5a2a55f53$var$load("3Cky6"),
    $411cc0d5a2a55f53$var$load("jL1Ke"),
    $411cc0d5a2a55f53$var$load("5MQ0D"),
    $411cc0d5a2a55f53$var$load("aFLSJ"),
    $411cc0d5a2a55f53$var$load("6fJCf"),
    $411cc0d5a2a55f53$var$load("duEFL"),
    $411cc0d5a2a55f53$var$load("6wr18"),
    $411cc0d5a2a55f53$var$load("1pJPT"),
    $411cc0d5a2a55f53$var$load("8zMmc"),
    $411cc0d5a2a55f53$var$load("4x9Jx"),
    $411cc0d5a2a55f53$var$load("7EorR"),
    $411cc0d5a2a55f53$var$load("ffEVr"),
    $411cc0d5a2a55f53$var$load("2EIkU"),
    $411cc0d5a2a55f53$var$load("Wowvf"),
    $411cc0d5a2a55f53$var$load("hhss7"),
    $411cc0d5a2a55f53$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("8Bx4L"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("8Bx4L", function(module, exports) {

let $643b6f94a2aaf625$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $643b6f94a2aaf625$var$load("iUXaE"),
    $643b6f94a2aaf625$var$load("lTkx9"),
    $643b6f94a2aaf625$var$load("6wr18"),
    $643b6f94a2aaf625$var$load("ffEVr"),
    $643b6f94a2aaf625$var$load("eCXJR"),
    $643b6f94a2aaf625$var$load("1VTX2"),
    $643b6f94a2aaf625$var$load("2EIkU"),
    $643b6f94a2aaf625$var$load("eRhBr"),
    $643b6f94a2aaf625$var$load("hZ2FX"),
    $643b6f94a2aaf625$var$load("hhss7"),
    $643b6f94a2aaf625$var$load("kT6dz"),
    $643b6f94a2aaf625$var$load("aAWLw"),
    $643b6f94a2aaf625$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("2mD9p"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("2mD9p", function(module, exports) {

let $1b8c016277d00b6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1b8c016277d00b6d$var$load("4ZKBo"),
    $1b8c016277d00b6d$var$load("3WmaY"),
    $1b8c016277d00b6d$var$load("7TnhR"),
    $1b8c016277d00b6d$var$load("hUbK8"),
    $1b8c016277d00b6d$var$load("gwGEC"),
    $1b8c016277d00b6d$var$load("l5nRU"),
    $1b8c016277d00b6d$var$load("bx5S2"),
    $1b8c016277d00b6d$var$load("7fsAO"),
    $1b8c016277d00b6d$var$load("1tkCm"),
    $1b8c016277d00b6d$var$load("ipIDQ"),
    $1b8c016277d00b6d$var$load("7eTC9"),
    $1b8c016277d00b6d$var$load("agv3Q"),
    $1b8c016277d00b6d$var$load("garBx"),
    $1b8c016277d00b6d$var$load("2CrXe"),
    $1b8c016277d00b6d$var$load("beMmd"),
    $1b8c016277d00b6d$var$load("l4MHo"),
    $1b8c016277d00b6d$var$load("k97np"),
    $1b8c016277d00b6d$var$load("3cN9G"),
    $1b8c016277d00b6d$var$load("j3345"),
    $1b8c016277d00b6d$var$load("2J2X1"),
    $1b8c016277d00b6d$var$load("dWa0D"),
    $1b8c016277d00b6d$var$load("jgxNN"),
    $1b8c016277d00b6d$var$load("e7Dyr"),
    $1b8c016277d00b6d$var$load("ig9dh"),
    $1b8c016277d00b6d$var$load("hA8hA"),
    $1b8c016277d00b6d$var$load("fldAO"),
    $1b8c016277d00b6d$var$load("46GUH"),
    $1b8c016277d00b6d$var$load("dxcsb"),
    $1b8c016277d00b6d$var$load("gbejv"),
    $1b8c016277d00b6d$var$load("GD9EA"),
    $1b8c016277d00b6d$var$load("2hLAI"),
    $1b8c016277d00b6d$var$load("dCilB"),
    $1b8c016277d00b6d$var$load("1T8H1"),
    $1b8c016277d00b6d$var$load("fyKFO"),
    $1b8c016277d00b6d$var$load("d9sg7"),
    $1b8c016277d00b6d$var$load("l0N35"),
    $1b8c016277d00b6d$var$load("gnocL"),
    $1b8c016277d00b6d$var$load("Kj0I8"),
    $1b8c016277d00b6d$var$load("5xnun"),
    $1b8c016277d00b6d$var$load("bgstx"),
    $1b8c016277d00b6d$var$load("8exG0"),
    $1b8c016277d00b6d$var$load("kT6dz"),
    $1b8c016277d00b6d$var$load("jZMUd"),
    $1b8c016277d00b6d$var$load("iUXaE"),
    $1b8c016277d00b6d$var$load("lTkx9"),
    $1b8c016277d00b6d$var$load("6wr18"),
    $1b8c016277d00b6d$var$load("bpmjT"),
    $1b8c016277d00b6d$var$load("hZVEi"),
    $1b8c016277d00b6d$var$load("fcsnw"),
    $1b8c016277d00b6d$var$load("ffEVr"),
    $1b8c016277d00b6d$var$load("eCXJR"),
    $1b8c016277d00b6d$var$load("1VTX2"),
    $1b8c016277d00b6d$var$load("ddvkk"),
    $1b8c016277d00b6d$var$load("3upHR"),
    $1b8c016277d00b6d$var$load("hhss7"),
    $1b8c016277d00b6d$var$load("Wowvf"),
    $1b8c016277d00b6d$var$load("eRhBr"),
    $1b8c016277d00b6d$var$load("hZ2FX"),
    $1b8c016277d00b6d$var$load("cKDij"),
    $1b8c016277d00b6d$var$load("7EorR"),
    $1b8c016277d00b6d$var$load("ce05o"),
    $1b8c016277d00b6d$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.0f08ed6d.js.map
